import React from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import "./gallery.css";
import { SiteHeader as Header, SiteFooter as Footer } from "./chrome.jsx";

const galleryItems = [
  {
    title: "Product Strategy Room",
    // type: "Studio",
    size: 'wide',
    image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=85'
  },
  {
    title: "Interface Review",
    // type: "Design",
    size: 'tall',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=900&q=85'
  },
  {
    title: "Cloud Systems Lab",
    // type: "Engineering",
    size: 'normal',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=900&q=85'
  },
  {
    title: "Team Planning",
    // type: "Culture",
    size: 'normal',
    image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=900&q=85'
  }
];

function ImagePopup({ item, onClose, onPrevious, onNext }) {
  const isOpen = Boolean(item);
  React.useEffect(() => {
    if (!isOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    const previousFocus = document.activeElement;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        onPrevious();
      }
      if (event.key === "ArrowRight") {
        event.preventDefault();
        onNext();
      }
    };

    document.body.style.overflow = "hidden";
    document.querySelector(".image-popup-close")?.focus();
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
      previousFocus?.focus();
    };
  }, [isOpen, onClose, onPrevious, onNext]);

  if (!item) return null;

  return (
    <div className="image-popup" role="presentation" onClick={onClose}>
      <div className="image-popup-box" role="dialog" aria-modal="true" aria-label={item.title} onClick={(event) => event.stopPropagation()}>
        <button className="image-popup-close" type="button" aria-label="Close" onClick={onClose}>
        </button>
        <img src={item.image} alt={item.title} />
        <button className="image-popup-nav image-popup-previous" type="button" aria-label="Previous photo" onClick={onPrevious}>
          <FaArrowLeft aria-hidden="true" />
        </button>
        <button className="image-popup-nav image-popup-next" type="button" aria-label="Next photo" onClick={onNext}>
          <FaArrowRight aria-hidden="true" />
        </button>
        <div className="image-popup-caption">
          <span>{item.type}</span>
          <strong>{item.title}</strong>
        </div>
      </div>
    </div>
  );
}

function Hero() {
  return (
    <section className="gallery-hero">
      <div className="hero-copy">
        <p className="section-kicker">OUR GALLERY</p>
        <h1>Moments from the way we <span>think, build and launch.</span></h1>
      </div>
    </section>
  );
}

function GalleryWall() {
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const closePopup = React.useCallback(() => setSelectedIndex(null), []);
  const previousPhoto = React.useCallback(() => {
    setSelectedIndex((index) => index === null ? null : (index - 1 + galleryItems.length) % galleryItems.length);
  }, []);
  const nextPhoto = React.useCallback(() => {
    setSelectedIndex((index) => index === null ? null : (index + 1) % galleryItems.length);
  }, []);

  return (
    <section className="gallery-section">
      <div className="gallery-grid">
        {galleryItems.map((item, index) => (
          <button className={`gallery-card ${item.size}`} type="button" aria-label={`View ${item.title}`} onClick={() => setSelectedIndex(index)} key={item.title}>
            <img src={item.image} alt={item.title} />
          </button>
        ))}
      </div>
      <ImagePopup item={selectedIndex === null ? null : galleryItems[selectedIndex]} onClose={closePopup} onPrevious={previousPhoto} onNext={nextPhoto} />
    </section>
  );
}

function App() {
  return (
    <>
      <Header />
      <main className="gallery-page">
        <Hero />
        <GalleryWall />
      </main>
      <Footer />
    </>
  );
}

export default App;
